module.exports = __webpack_public_path__ + "static/media/Rubik-Bold.493f2062.ttf";